/**
 * DeleteReasonModal — confirmation de suppression (soft-delete) avec motif OBLIGATOIRE (3 car. min).
 * R2 (iter393) : s'appuie sur DeskConfirm `withReason`. Motif exigé côté serveur aussi.
 */
import DeskConfirm from "@/components/crm/DeskConfirm";

export default function DeleteReasonModal({ open = true, onClose, onConfirm, busy = false, entityLabel = "cet élément", entityRef = "", headline = "Supprimer", helperText = "L'élément est envoyé en corbeille et purgé automatiquement après 30 jours." }) {
  const title = /\?\s*$/.test(headline) ? headline : `${headline} ${entityLabel}${entityRef ? ` ${entityRef}` : ""} ?`;
  return (
    <DeskConfirm open={open} title={title} message={helperText} busy={busy} withReason reasonPlaceholder="Motif de suppression (obligatoire)"
      confirmLabel={busy ? "Suppression…" : "Supprimer"} onClose={() => { if (!busy) onClose?.(); }} onConfirm={(reason) => onConfirm(reason)} testId="delete-reason-modal" />
  );
}
